// src/utils/ScrollToSection.js
export const scrollToSection = (id) => {
    const sectionId = id.replace("#", "");
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  